import { get } from 'lodash-es';

import { EMPTY_OBJ } from '~/core/shared/constants';
import { AnyDocument } from '~/core/shared/types';

// Replaces placeholders in the template using values from parentContext.
// If a value is missing, keeps the placeholder as-is.
export const replaceFromParentContext = (
  template: string,
  parentContext?: AnyDocument,
): string =>
  template.replace(/\{([\w.]+)\}/g, (_, keyPath: string) => {
    const existingTemplate = `{${keyPath}}`;
    const fromParent = get(
      parentContext || EMPTY_OBJ,
      keyPath.split('.'),
      existingTemplate,
    );

    return fromParent === undefined ? existingTemplate : fromParent;
  });
